import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { useTranslation } from 'react-i18next';
import { formatHoursForDisplay, type Hours } from '../../utils/hours-helper';

interface HoursDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  hours: Hours | undefined | null;
  title: string;
}

export default function HoursDialog({
  open,
  onOpenChange,
  hours,
  title,
}: HoursDialogProps) {
  const { t } = useTranslation();

  if (!hours || Object.keys(hours).length === 0) {
    return null;
  }

  const formattedHours = formatHoursForDisplay(hours);

  if (!formattedHours) {
    return null;
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <div className="space-y-3">
          {formattedHours.map((day) => (
            <div key={day.day} className="flex justify-between items-start">
              <span className="font-medium text-sm min-w-20">{t(`days.${day.day}`)}</span>
              {day.status === 'closed' ? (
                <span className="text-sm text-muted-foreground">{t('locationInfo.closed')}</span>
              ) : (
                <div className="flex flex-col items-end gap-1">
                  {day.ranges.map((range, idx) => (
                    <span key={idx} className="text-sm">
                      {range.open} - {range.close}
                    </span>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
